import {
    FeedPostDropDown,
    // PostMediaVid,
    PostText,
    PostUserBlock,
    SocialCount,
    VideoPlayer
} from "ui";

import vid from "assets/videos/vi1.mp4";

const FeedPost5 = () => {
    return (
        <div className="card is-post mb-20 mt-20">
            {/* <!-- Main wrap --> */}
            <div className={`content-wrap`}>
                {/* <!-- Post header --> */}
                <div className="card-heading">
                    {/* <!-- User meta --> */}
                    <PostUserBlock />
                    {/* Right side dropdown */}
                    <FeedPostDropDown />
                </div>
                {/* <!-- /Post header --> */}

                {/* <!-- Post body --> */}
                <div className="card-body">
                    {/* <!-- Post body text --> */}
                    <PostText text="Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!" />
                    {/* <!-- Featured image --> */}
                    {/* <PostMediaVid postId={"500"} vid={vid} /> */}
                    <VideoPlayer src={vid} />
                </div>
                {/* <!-- /Post body --> */}

                {/* <!-- Post footer --> */}
                <div className="card-footer">
                    <SocialCount />
                </div>
                {/* <!-- /Post footer --> */}
            </div>
            {/* <!-- /Main wrap --> */}
        </div>
    );
};

export default FeedPost5;
